// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&family=Playfair+Display:ital,wght@0,400;0,500;0,600;0,700;1,400&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   HomePage Teste — Identidade Visual Babita atual
   Creme #FAF8F5 / Preto #0A0A0A · wordmark · Montserrat/Playfair
   Classes prefixadas .tp- para nao colidir com homePage.css
   ============================================================ */

:root{
    --tp-creme: #FAF8F5;
    --tp-preto: #0A0A0A;
    --tp-preto-soft: #1c1a19;
    --tp-linha: #e6e0d8;
    --tp-cinza-txt: #6b6560;
    --tp-wpp: #25D366;
}

.tp-page,
.tp-page *{ box-sizing: border-box; }

.tp-page{
    min-height: 100vh;
    width: 100%;
    background-color: var(--tp-creme);
    color: var(--tp-preto);
    font-family: 'Montserrat', sans-serif;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 20px 60px;
    overflow-x: hidden;
}

.tp-header{
    width: 100%;
    max-width: 560px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 9vh;
}

.tp-logo{
    width: 230px;
    max-width: 62vw;
    height: auto;
    color: var(--tp-preto);
    opacity: 0;
    transform: translateY(14px);
    animation: tpFadeUp 0.7s ease-out 0.15s forwards;
}

.tp-tagline{
    margin-top: 16px;
    font-family: 'Playfair Display', serif;
    font-style: italic;
    font-size: 1.05rem;
    color: var(--tp-cinza-txt);
    letter-spacing: 0.2px;
    text-align: center;
    opacity: 0;
    animation: tpFadeUp 0.7s ease-out 0.3s forwards;
}

.tp-card{
    width: 100%;
    max-width: 480px;
    margin-top: 7vh;
    background: #ffffff;
    border: 1px solid var(--tp-linha);
    border-radius: 16px;
    padding: 36px 28px 32px;
    box-shadow: 0 18px 40px -24px rgba(10,10,10,0.25);
    opacity: 0;
    transform: translateY(18px);
    animation: tpFadeUp 0.7s ease-out 0.4s forwards;
}

.tp-title{
    font-family: 'Playfair Display', serif;
    font-weight: 600;
    font-size: 1.7rem;
    line-height: 1.25;
    text-align: center;
    margin: 0 0 10px;
}

.tp-subtitle{
    text-align: center;
    font-size: 0.95rem;
    font-weight: 300;
    color: var(--tp-cinza-txt);
    margin: 0 auto 26px;
    max-width: 38ch;
}

.tp-field{ display: flex; gap: 10px; flex-direction: column; }

.tp-input{
    width: 100%;
    height: 54px;
    border: 1px solid var(--tp-linha);
    border-radius: 10px;
    background: var(--tp-creme);
    padding: 0 18px;
    font-family: 'Montserrat', sans-serif;
    font-size: 1.1rem;
    letter-spacing: 2px;
    text-align: center;
    color: var(--tp-preto);
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.tp-input::placeholder{ letter-spacing: 0.5px; color: #b3aca4; }

.tp-input:focus{
    outline: none;
    border-color: var(--tp-preto);
    box-shadow: 0 0 0 3px rgba(10,10,10,0.06);
}

.tp-btn{
    width: 100%;
    height: 54px;
    border: none;
    border-radius: 10px;
    background: var(--tp-preto);
    color: var(--tp-creme);
    font-family: 'Montserrat', sans-serif;
    font-weight: 600;
    font-size: 0.95rem;
    letter-spacing: 1px;
    text-transform: uppercase;
    cursor: pointer;
    transition: transform 0.15s ease, background 0.2s ease;
}

.tp-btn:hover{ background: var(--tp-preto-soft); transform: translateY(-1px); }
.tp-btn:active{ transform: translateY(0); }

.tp-btn--ghost{
    background: transparent;
    color: var(--tp-preto);
    border: 1px solid var(--tp-preto);
}
.tp-btn--ghost:hover{ background: var(--tp-preto); color: var(--tp-creme); }

.tp-feedback{
    text-align: center;
    font-size: 0.9rem;
    color: var(--tp-cinza-txt);
    margin-top: 18px;
}

.tp-results-head{ text-align: center; margin-bottom: 18px; }
.tp-results-head .tp-title{ font-size: 1.4rem; margin-bottom: 4px; }

.tp-vend{
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 14px 8px;
    border-bottom: 1px solid var(--tp-linha);
}
.tp-vend:last-of-type{ border-bottom: none; }

.tp-vend-foto{
    width: 56px;
    height: 56px;
    flex: 0 0 56px;
    border-radius: 50%;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    border: 1px solid var(--tp-linha);
}

.tp-vend-info{ flex: 1 1; min-width: 0; }

.tp-vend-nome{
    font-family: 'Playfair Display', serif;
    font-weight: 600;
    font-size: 1.05rem;
    color: var(--tp-preto);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.tp-vend-label{
    font-size: 0.78rem;
    color: var(--tp-cinza-txt);
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.tp-wpp{
    flex: 0 0 auto;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    text-decoration: none;
    background: var(--tp-wpp);
    color: #fff;
    font-weight: 600;
    font-size: 0.85rem;
    padding: 10px 16px;
    border-radius: 999px;
    transition: filter 0.2s ease;
}
.tp-wpp:hover{ filter: brightness(0.94); }
.tp-wpp svg{ width: 18px; height: 18px; fill: currentColor; }

.tp-actions{ display: flex; flex-direction: column; gap: 10px; margin-top: 22px; }

.tp-footer{
    margin-top: auto;
    padding-top: 40px;
    font-size: 0.75rem;
    color: #b3aca4;
    text-align: center;
    letter-spacing: 0.5px;
}

@keyframes tpFadeUp{ to{ opacity: 1; transform: translateY(0); } }

@media (max-width: 520px){
    .tp-header{ padding-top: 7vh; }
    .tp-card{ padding: 28px 20px 26px; }
    .tp-title{ font-size: 1.45rem; }
    .tp-wpp span{ display: none; }
    .tp-wpp{ padding: 12px; }
    .tp-vend-nome{ font-size: 0.98rem; }
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/homePageTeste.css"],"names":[],"mappings":"AAAA;;;;iEAIiE;;AAIjE;IACI,mBAAmB;IACnB,mBAAmB;IACnB,wBAAwB;IACxB,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;YACY,sBAAsB,EAAE;;AAEpC;IACI,iBAAiB;IACjB,WAAW;IACX,iCAAiC;IACjC,sBAAsB;IACtB,qCAAqC;IACrC,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,sBAAsB;IACtB,UAAU;IACV,2BAA2B;IAC3B,gDAAgD;AACpD;;AAEA;IACI,gBAAgB;IAChB,sCAAsC;IACtC,kBAAkB;IAClB,kBAAkB;IAClB,0BAA0B;IAC1B,qBAAqB;IACrB,kBAAkB;IAClB,UAAU;IACV,+CAA+C;AACnD;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,iCAAiC;IACjC,mBAAmB;IACnB,uBAAuB;IACvB,iDAAiD;IACjD,UAAU;IACV,2BAA2B;IAC3B,+CAA+C;AACnD;;AAEA;IACI,sCAAsC;IACtC,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,0BAA0B;IAC1B,mBAAmB;IACnB,eAAe;AACnB;;AAEA,WAAW,aAAa,EAAE,SAAS,EAAE,sBAAsB,EAAE;;AAE7D;IACI,WAAW;IACX,YAAY;IACZ,iCAAiC;IACjC,mBAAmB;IACnB,2BAA2B;IAC3B,eAAe;IACf,qCAAqC;IACrC,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;IACtB,wDAAwD;AAC5D;;AAEA,wBAAwB,qBAAqB,EAAE,cAAc,EAAE;;AAE/D;IACI,aAAa;IACb,6BAA6B;IAC7B,yCAAyC;AAC7C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,2BAA2B;IAC3B,sBAAsB;IACtB,qCAAqC;IACrC,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;IACf,sDAAsD;AAC1D;;AAEA,eAAe,gCAAgC,EAAE,2BAA2B,EAAE;AAC9E,gBAAgB,wBAAwB,EAAE;;AAE1C;IACI,uBAAuB;IACvB,sBAAsB;IACtB,iCAAiC;AACrC;AACA,sBAAsB,2BAA2B,EAAE,sBAAsB,EAAE;;AAE3E;IACI,kBAAkB;IAClB,iBAAiB;IACjB,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA,kBAAkB,kBAAkB,EAAE,mBAAmB,EAAE;AAC3D,4BAA4B,iBAAiB,EAAE,kBAAkB,EAAE;;AAEnE;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,iBAAiB;IACjB,wCAAwC;AAC5C;AACA,uBAAuB,mBAAmB,EAAE;;AAE5C;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;IAC5B,iCAAiC;AACrC;;AAEA,eAAe,SAAO,EAAE,YAAY,EAAE;;AAEtC;IACI,sCAAsC;IACtC,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,0BAA0B;IAC1B,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,qBAAqB;IACrB,yBAAyB;IACzB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,oBAAoB;IACpB,4BAA4B;AAChC;AACA,eAAe,wBAAwB,EAAE;AACzC,aAAa,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE;;AAE5D,aAAa,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE,gBAAgB,EAAE;;AAEjF;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA,qBAAqB,IAAI,UAAU,EAAE,wBAAwB,EAAE,EAAE;;AAEjE;IACI,YAAY,gBAAgB,EAAE;IAC9B,UAAU,uBAAuB,EAAE;IACnC,WAAW,kBAAkB,EAAE;IAC/B,cAAc,aAAa,EAAE;IAC7B,SAAS,aAAa,EAAE;IACxB,eAAe,kBAAkB,EAAE;AACvC","sourcesContent":["/* ============================================================\n   HomePage Teste — Identidade Visual Babita atual\n   Creme #FAF8F5 / Preto #0A0A0A · wordmark · Montserrat/Playfair\n   Classes prefixadas .tp- para nao colidir com homePage.css\n   ============================================================ */\n\n@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&family=Playfair+Display:ital,wght@0,400;0,500;0,600;0,700;1,400&display=swap');\n\n:root{\n    --tp-creme: #FAF8F5;\n    --tp-preto: #0A0A0A;\n    --tp-preto-soft: #1c1a19;\n    --tp-linha: #e6e0d8;\n    --tp-cinza-txt: #6b6560;\n    --tp-wpp: #25D366;\n}\n\n.tp-page,\n.tp-page *{ box-sizing: border-box; }\n\n.tp-page{\n    min-height: 100vh;\n    width: 100%;\n    background-color: var(--tp-creme);\n    color: var(--tp-preto);\n    font-family: 'Montserrat', sans-serif;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 0 20px 60px;\n    overflow-x: hidden;\n}\n\n.tp-header{\n    width: 100%;\n    max-width: 560px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding-top: 9vh;\n}\n\n.tp-logo{\n    width: 230px;\n    max-width: 62vw;\n    height: auto;\n    color: var(--tp-preto);\n    opacity: 0;\n    transform: translateY(14px);\n    animation: tpFadeUp 0.7s ease-out 0.15s forwards;\n}\n\n.tp-tagline{\n    margin-top: 16px;\n    font-family: 'Playfair Display', serif;\n    font-style: italic;\n    font-size: 1.05rem;\n    color: var(--tp-cinza-txt);\n    letter-spacing: 0.2px;\n    text-align: center;\n    opacity: 0;\n    animation: tpFadeUp 0.7s ease-out 0.3s forwards;\n}\n\n.tp-card{\n    width: 100%;\n    max-width: 480px;\n    margin-top: 7vh;\n    background: #ffffff;\n    border: 1px solid var(--tp-linha);\n    border-radius: 16px;\n    padding: 36px 28px 32px;\n    box-shadow: 0 18px 40px -24px rgba(10,10,10,0.25);\n    opacity: 0;\n    transform: translateY(18px);\n    animation: tpFadeUp 0.7s ease-out 0.4s forwards;\n}\n\n.tp-title{\n    font-family: 'Playfair Display', serif;\n    font-weight: 600;\n    font-size: 1.7rem;\n    line-height: 1.25;\n    text-align: center;\n    margin: 0 0 10px;\n}\n\n.tp-subtitle{\n    text-align: center;\n    font-size: 0.95rem;\n    font-weight: 300;\n    color: var(--tp-cinza-txt);\n    margin: 0 auto 26px;\n    max-width: 38ch;\n}\n\n.tp-field{ display: flex; gap: 10px; flex-direction: column; }\n\n.tp-input{\n    width: 100%;\n    height: 54px;\n    border: 1px solid var(--tp-linha);\n    border-radius: 10px;\n    background: var(--tp-creme);\n    padding: 0 18px;\n    font-family: 'Montserrat', sans-serif;\n    font-size: 1.1rem;\n    letter-spacing: 2px;\n    text-align: center;\n    color: var(--tp-preto);\n    transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.tp-input::placeholder{ letter-spacing: 0.5px; color: #b3aca4; }\n\n.tp-input:focus{\n    outline: none;\n    border-color: var(--tp-preto);\n    box-shadow: 0 0 0 3px rgba(10,10,10,0.06);\n}\n\n.tp-btn{\n    width: 100%;\n    height: 54px;\n    border: none;\n    border-radius: 10px;\n    background: var(--tp-preto);\n    color: var(--tp-creme);\n    font-family: 'Montserrat', sans-serif;\n    font-weight: 600;\n    font-size: 0.95rem;\n    letter-spacing: 1px;\n    text-transform: uppercase;\n    cursor: pointer;\n    transition: transform 0.15s ease, background 0.2s ease;\n}\n\n.tp-btn:hover{ background: var(--tp-preto-soft); transform: translateY(-1px); }\n.tp-btn:active{ transform: translateY(0); }\n\n.tp-btn--ghost{\n    background: transparent;\n    color: var(--tp-preto);\n    border: 1px solid var(--tp-preto);\n}\n.tp-btn--ghost:hover{ background: var(--tp-preto); color: var(--tp-creme); }\n\n.tp-feedback{\n    text-align: center;\n    font-size: 0.9rem;\n    color: var(--tp-cinza-txt);\n    margin-top: 18px;\n}\n\n.tp-results-head{ text-align: center; margin-bottom: 18px; }\n.tp-results-head .tp-title{ font-size: 1.4rem; margin-bottom: 4px; }\n\n.tp-vend{\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    padding: 14px 8px;\n    border-bottom: 1px solid var(--tp-linha);\n}\n.tp-vend:last-of-type{ border-bottom: none; }\n\n.tp-vend-foto{\n    width: 56px;\n    height: 56px;\n    flex: 0 0 56px;\n    border-radius: 50%;\n    background-size: cover;\n    background-position: center;\n    background-repeat: no-repeat;\n    border: 1px solid var(--tp-linha);\n}\n\n.tp-vend-info{ flex: 1; min-width: 0; }\n\n.tp-vend-nome{\n    font-family: 'Playfair Display', serif;\n    font-weight: 600;\n    font-size: 1.05rem;\n    color: var(--tp-preto);\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.tp-vend-label{\n    font-size: 0.78rem;\n    color: var(--tp-cinza-txt);\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n.tp-wpp{\n    flex: 0 0 auto;\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    text-decoration: none;\n    background: var(--tp-wpp);\n    color: #fff;\n    font-weight: 600;\n    font-size: 0.85rem;\n    padding: 10px 16px;\n    border-radius: 999px;\n    transition: filter 0.2s ease;\n}\n.tp-wpp:hover{ filter: brightness(0.94); }\n.tp-wpp svg{ width: 18px; height: 18px; fill: currentColor; }\n\n.tp-actions{ display: flex; flex-direction: column; gap: 10px; margin-top: 22px; }\n\n.tp-footer{\n    margin-top: auto;\n    padding-top: 40px;\n    font-size: 0.75rem;\n    color: #b3aca4;\n    text-align: center;\n    letter-spacing: 0.5px;\n}\n\n@keyframes tpFadeUp{ to{ opacity: 1; transform: translateY(0); } }\n\n@media (max-width: 520px){\n    .tp-header{ padding-top: 7vh; }\n    .tp-card{ padding: 28px 20px 26px; }\n    .tp-title{ font-size: 1.45rem; }\n    .tp-wpp span{ display: none; }\n    .tp-wpp{ padding: 12px; }\n    .tp-vend-nome{ font-size: 0.98rem; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
